<template class="content-center bg-[#fafbfc] font-['Poppins']">
  <!-- page meta -->
  <div>
    <Head>
      <title>Platforma | Free Signup</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Get Started for free creating a private membership site platform to monetize your content."
      />
    </Head>
  </div>
  <!-- content start -->
  <div
    class="gradient-background bg-bottom mx-auto bg-no-repeat h-full pb-[225px]"
  >
    <header>
      <div
        class="max-w-[1500px] flex justify-between p-5 bg-transparent mx-auto"
      >
        <div class="md:p-[10px] p-[30px] mx-auto md:ml-0">
          <!-- logo -->
          <Link href="/" class="lg:min-w-[120px]">
            <img
              :src="$filters.media_path('images/platforma-logo-in-color.svg')"
              alt="Platforma Online Course Builder Header Logo"
          /></Link>
        </div>
        <div class="flex p-[10px]">
          <h3 class="text-[#7C828D] hidden md:block font-medium my-auto">
            Already earning with Platforma?
          </h3>
          <Link href="/login">
            <button
              class="header-login-button ml-3.5 h-[42px] w-[101px] bg-[#2D8CFF] rounded-[9px] text-sm font-semibold text-white shadow-[0_4px_14px_0_rgba(34,85,198,0.31)] duration-300 hover:ease-in-out hover:bg-[#1B67C2] hidden md:block"
            >
              Login
            </button>
          </Link>
        </div>
      </div>
    </header>
    <!-- form -->
    <section class="w-full py-auto pt-[25px] sm:pt-[75px] h-full">
      <!-- signup card -->
      <div
        class="relative bg-white mx-[20px] min-[480px]:mx-auto min-[480px]:w-[480px] h-[513px] rounded-[10px] drop-shadow-[0_35px_35px_rgba(0,0,0,0.25)] my-auto pt-6"
      >
        <h1 class="text-center text-[36px] font-bold">Let’s go!</h1>

        <!-- signup form -->
        <div class="mx-auto px-[20px] min-[464px]:px-[78px] mt-[20px]">
          <form
            method="POST"
            action="/free-signup-quick-survey/captureEmail"
            class=""
          >
            <!-- first name field -->
            <div class="flex flex-col mx-auto mb-5">
              <label
                for="fullName"
                class="my-auto text-[#292D34] font-normal text-[11px]"
                >First Name</label
              >
              <input
                type="text"
                name="fullName"
                id="fullName"
                class="first-name-input bg-[left_16px_top_10px] bg-no-repeat pl-[46px] mt-1 h-10 w-full rounded-lg border border-[#d1d1d160] border-slate-300 bg-white py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                required
                placeholder="John Doe"
              />
            </div>

            <!-- email field -->
            <div class="flex flex-col mx-auto mb-5">
              <label
                for="email"
                class="my-auto text-[#292D34] font-normal text-[11px] after:ml-0.5"
                >Email</label
              >
              <input
                type="text"
                name="email"
                id="email"
                class="email-input bg-[left_16px_top_11px] bg-no-repeat pl-[46px] mt-1 h-10 w-full rounded-lg border border-[#d1d1d160] border-slate-300 bg-white py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                required
                placeholder="youremail@here.com"
              />
            </div>

            <!-- work email field -->
            <div class="flex flex-col relative mx-auto mb-5">
              <label
                for="password"
                class="my-auto text-[#292D34] font-normal text-[11px] after:ml-0.5"
                >Choose Password</label
              >

              <input
                type="text"
                name="password"
                id="password"
                class="password-input bg-[left_16px_top_11px] bg-no-repeat pl-[46px] pr-[50px] mt-1 h-10 w-full rounded-lg border border-[#d1d1d160] border-slate-300 bg-white py-2 placeholder-slate-400 shadow-sm focus:border-[#2d8bff] focus:outline-none focus:ring-1 focus:ring-[#2d8bff] sm:text-sm"
                required
                placeholder="Minimum 6 Characters"
              />
              <a
                class="text-[#2d8bff] absolute cursor-pointer mt-[30px] right-0 mr-3 text-sm"
                >Show
              </a>
            </div>
          </form>

          <button
            class="mt-[10px] w-full transition px-[35px] my-auto mx-auto h-[56px] rounded-lg bg-[#2d8bff] text-[15px] font-semibold text-white active:bg-[#054ca3] hover:bg-[#1B67C2] dark:border-none hover:ease-in hover:transition duration-1000 hover:delay-200 drop-shadow-[0px_10px_25px_#64A7F9]"
          >
            Earn with Platforma
          </button>
        </div>

        <div
          class="absolute inset-x-0 bottom-0 border-t w-full border-[#E9EBF0] bg-[#FAFBFC] h-8 rounded-b-lg"
        >
          <h5
            class="mt-[5px] text-[#7C828D] text-center mx-auto text-[8px] min-[410px]:text-[10px] font-normal my-auto"
          >
            By clicking the button above, you agree to our
            <a
              target="_blank"
              class="font-semibold"
              href="https://platformarea.com/terms"
              >Terms of Service</a
            >
            and
            <a
              target="_blank"
              class="font-semibold"
              href="https://platformarea.com/privacy"
            >
              Privacy Policy.</a
            >
          </h5>
        </div>
      </div>
      <div class="text-sm font-semibold mx-auto mt-[30px]">
        <h4 class="text-white text-center mx-auto text-sm font-semibold">
          See why 10,000+ entrepreneurs earn more with Platforma
        </h4>
      </div>
    </section>
  </div>
</template>

<script setup></script>

<style>
.gradient-background {
  background-image: url(../media/images/free-signup-survey-bg.svg);
}

.first-name-input {
  background-image: url(../media/images/name-input-icon.svg);
}
.email-input {
  background-image: url(../media/images/email-input-icon.svg);
}
.password-input {
  background-image: url(../media/images/password-lock-input-icon.svg);
}
</style>
